export class Branching {
    public id: string;
    public items: BranchingItems[];

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            json.forEach(element => {
                this.id = element.id;
                if (element.items && element.items.length > 0) {
                    this.items = element.items.map((valueJson: any) => new BranchingItems(valueJson));
                }
            });

        }
    }
}

export class BranchingInfo {
    public startAddress: string;
    public endAddress: string;
    public polyline: string;
    public summary: string;
    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.startAddress = json.startAddress;
            this.endAddress = json.endAddress;
            this.polyline = json.polyline;
            this.summary = json.summary;
        }
    }
}
export class BranchingItems {
    public time: string;
    public branchingInfo: BranchingInfo;
    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.time = json.time;
            this.branchingInfo = json.brachInfo;
        }
    }
}
export class RouteInformation {
    constructor(public Color: string,
        public Route: string,
        public Distance: string,
        public Duration: string,
        public Percentage: number) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/branching.ts